<template>
  <div>
    <Nav isActive="2" :isIndex="isIndex" />
    <div class="p100 pageWD" style="height:500px">
      课程师资课程师资
    </div>
    <Fotter />
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Fotter from "@/components/Fotter.vue";
export default {
  name: "bmtd",
  components: { Nav, Fotter },
  data() {
    return {
      vlist: [
        {
          hide: false,
          isrc: "http://h5.shihua.com/static/yunxue/c1.png",
          src: "https://yunxue-bucket.oss-cn-shanghai.aliyuncs.com/shcms/video/%E6%9D%9C%E9%95%BF%E6%98%A5.mp4",
        },
      ],
    };
  },
};
</script>
<style scoped>
.about_s1 {
  background: url("http://h5.shihua.com/static/yunxue/about_bg.png") repeat-x;
}
.jnm {
  font-size: 36px;
  color: #333;
  font-weight: 800;
  position: relative;
  padding-bottom:40px;
  padding-top:40px
}
.jnm:after{
  content: '';
  position: absolute;
  bottom:20px;
  width: 54px;
  height: 6px;
  background: #25a2dd;
  left:0
} 
.ctt {
  background: url("http://h5.shihua.com/static/yunxue/picbg.png") no-repeat;
  width: 553px;
  height: 195px;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  padding: 25px 40px;
  position: relative;
  left:-15px
}
</style>


// WEBPACK FOOTER //
// src/views/kcsz/index.vue